import script from "./SubmitEntryConfirmationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubmitEntryConfirmationModal.vue?vue&type=script&setup=true&lang=ts"

import "./SubmitEntryConfirmationModal.vue?vue&type=style&index=0&id=60d1e8fe&scoped=true&lang=css"

import exportComponent from "E:\\Sites\\mk64\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60d1e8fe"]])

export default __exports__